<div class="ny-white-page-header">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-5 col-5 col-xl-3">
        <a routerLink="/">
          <img src="/assets/img/logo.png" class="img-fluid ny-logo" alt="img" />
        </a>
      </div>
      <div class="col-md-7 col-7 col-xl-9 text-right">
        <span>Secure Checkout </span>
        <img src="/assets/img/ny-card.png" class="img-fluid ny-c-image" alt="img" />
      </div>
    </div>
  </div>
</div>


<section class="ny-text-section">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="ny-confirmation">
          <img src="/assets/img/n-false.png" alt="img" />
          <h1>Sorry, Your order could not be completed!</h1>
          <p>
            Please check your payment method and try again or contact one of your sales representatives.
          </p>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-12 text-center">
        <a routerLink="/cart" class="btn ny-btn">
          Return to shopping cart
        </a>
      </div>
    </div>
  </div>
</section>



<div class="">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="list-ul text-left">
          <a href="">
            Terms &amp; Conditions
          </a>
          <a href="">
            Privacy Policy
          </a>
          <a href="">
            Delivery Policy
          </a>
          <a href="">
            Return Policy
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
